<template>
  <div class="left-sidebar mgr-22 mgt-33">
    <div class="d-flex justify-content-between">
      <div class="t-body2 t-color-bodyGrayA font-r">{{ $t("30012") }}</div>
      <div class="t-body2 t-color-secondaryBtnText font-r cursor-pointer" @click="resetFilter">{{ $t("30013") }}</div>
    </div>
    <div class="divider mgt-18"></div>
    <div v-for="(aggregation, index) in aggregationData" :key="index">
	    <div v-if="aggregation.type === 'REVIEW'">
		    <!-- REVIEW ALL -->
		    <div :class="{'bg-primarySelected' : !isReviewCollapsed }"
		         class="d-flex justify-content-between align-items-center pdl-20 pdr-4 mgt-12 b-radius4 mgb-12 cursor-pointer"
		         @click="toggleMoreMethod">
			    <div class="t-body2 t-color-primary font-r">{{ $t("30093") }}</div>
			    <button class="mdc-icon-button content-trigger h-40 d-flex align-items-center" tabindex="0">
				    <i class="material-icons t-headline12 t-color-bodyGrayA toggle">{{isReviewCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</i>
			    </button>
		    </div>
		    <div :style="isReviewCollapsed ? { 'display': 'none' } : {'display': 'block'}" class="detail-content">
			    <div v-for="(rate, index) in ratingObj"
			         :key="index"
			         class="pdt-4 pdb-4 pdl-20 pdr-20 d-flex align-items-center">
				    <div class="mdc-form-field">
					    <div :class="{'mdc-radio--disabled' : isStarDisable(rate.value)}"
					         class="mdc-radio mdc--radio__custom mgr-0">
						    <input :id="'radio-' + index"
						           v-model="aggregation.value"
						           :disabled="isStarDisable(rate.value)"
						           :value="rate.value"
						           class="mdc-radio__native-control"
						           name="aggregation.type"
						           type="radio"
						           @change="onFilterChange">
						    <div class="mdc-radio__background">
							    <div class="mdc-radio__outer-circle"></div>
							    <div class="mdc-radio__inner-circle"></div>
						    </div>
						    <div class="mdc-radio__ripple"></div>
					    </div>
				    </div>
				    <div v-if="index > 0" class="d-flex">
					    <i v-for="i in 5"
					       :key="i"
					       :class="{'selected': i < rate.value + 1}"
					       class="material-icons t-color-iconInactive mgr-1 star font-18">star</i>
				    </div>
				    <div v-else class="d-flex t-color-bodyGrayA t-body2 font-r">
					    {{ $t(rate.languageCode) }}
				    </div>
				    <div v-if="index > 0"
				         :class="isStarDisable(rate.value) ? 't-color-iconInactive' : 't-color-bodyGrayA'"
				         class="t-body2 font-r mgl-11">
					    {{ $t(rate.languageCode) }} ({{ getStarCount(rate.value) }})
				    </div>
			    </div>
		    </div>
	    </div>


	    <div v-else>
	      <filter-tab v-if="!languageTypes.includes(aggregation.type) || (languageTypes.includes(aggregation.type) && aggregation.options.length)"
	                  :aggregation="aggregation"
	                  :isToggle="index > 3"
	                  @onCheckChange="onFilterChange"></filter-tab>
	    </div>
      <div class="divider mgt-8"></div>
    </div>
  </div>
</template>

<script>
import {FILTER_LIST} from '@/components/microDegree/utils/constants.js';
import DisplayFile from "@/components/socialLearning/DisplayFile";

export default {
  name: "FilterBar",

  props: ['aggregationData'],

  components: {
	  DisplayFile,
    'filter-tab': () => import('@/components/microDegree/view/FilterTab')
  },

	computed: {
	
	},
  data() {
    return {
	    languageTypes: [FILTER_LIST.course_language, FILTER_LIST.subtitle_language],
	    isReviewCollapsed: false,
	    review: null,
      starList: [],
      reviewList: [],
      aggregationList: [],
      ratingObj: [
	      {
		      value: '',
		      languageCode: '30094',
	      },
        {
          value: 5.00,
          languageCode: '30017',
        },
        {
          value: 4.00,
          languageCode: '30018',
        },
        {
          value: 3.00,
          languageCode: '30019',
        },
      ]
    }
  },

  methods: {
    getStarCount(review) {
			if (review === '') {
				return;
			}
	    const reviews = this.aggregationData.find(aggregation => aggregation.type === FILTER_LIST.review.name);
	    const options = reviews.options.find(option => parseInt(option.title) === review);
	    return options.count ? options.count : 0;
    },
	
	  isStarDisable(rateValue) {
		  return rateValue !== '' && !this.getStarCount(rateValue);
	  },
	  
    resetFilter() {
      const checkbox = document.querySelectorAll('.mdc-checkbox__native-control');
      checkbox.forEach((item) => {
        item.checked = false;
        item.classList.remove('mdc-checkbox--selected');
      })
      this.$emit('resetFilter');
    },

    onFilterChange() {
	    this.$emit('callNewFilterList');
    },

    toggleMoreMethod() {
      this.isReviewCollapsed = !this.isReviewCollapsed;
    }
  }
}
</script>

<style scoped>
.font-18{
  font-size: 18px;
}
.mgr-0{
  margin-right: 0 !important;
}
</style>
